<template>
    <div style="display: inline-block">
        <a
            href="#compatibility"
            class="popup-link"
            @click.prevent="isCompatibilitiesPopupOpen = true"
            :title="t.frontend.compatibility_notes"
        >
            ({{ t.frontend.compatibility_notes }})
        </a>
        <CompatibilityPopupPackage v-if="isCompatibilitiesPopupOpen" @close="closeCompatibilities" :packageId="id" />
    </div>
</template>

<script>
import CompatibilityPopupPackage from "@/components/Frontend/CompatibilityPopupPackage.vue"
const translationsData = window.translationsData

export default {
    name: "PackageActionsButtons",
    components: { CompatibilityPopupPackage },
    props: ["id"],
    data() {
        return {
            isCompatibilitiesPopupOpen: false,
            t: translationsData.translations,
        }
    },
    created() {},
    destroyed() {
        window.removeEventListener("keyup", this.closeOnESC)
    },
    methods: {
        closeCompatibilities() {
            this.isCompatibilitiesPopupOpen = false
        },
        closeOnESC(event) {
            if (parseInt(event.keyCode) === 27) {
                this.isPopupOpen = false
            }
        },
    },
}
</script>
